var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4852 2.73136H15.1334C14.5957 1.14717 13.1874 0 11.5229 0C9.85851 0 8.45015 1.14717 7.91241 2.73136H2.56065C1.15229 2.73136 0 3.96047 0 5.46272V24.5822C0 26.0845 1.15229 27.3136 2.56065 27.3136H20.4852C21.8936 27.3136 23.0459 26.0845 23.0459 24.5822V5.46272C23.0459 3.96047 21.8936 2.73136 20.4852 2.73136ZM11.5229 2.73136C12.2271 2.73136 12.8033 3.34592 12.8033 4.09704C12.8033 4.84817 12.2271 5.46272 11.5229 5.46272C10.8188 5.46272 10.2426 4.84817 10.2426 4.09704C10.2426 3.34592 10.8188 2.73136 11.5229 2.73136ZM14.0836 21.8509H5.1213V19.1195H14.0836V21.8509ZM17.9246 16.3882H5.1213V13.6568H17.9246V16.3882ZM17.9246 10.9254H5.1213V8.19408H17.9246V10.9254Z",
    fill: "#004BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.7868e18fffd86f881a900228e985d5f0.svg";
export { ForwardRef as ReactComponent };